import React, { Component } from "react";
import { API, Storage } from "aws-amplify";
import { s3Upload } from "../libs/awsLib";
import { Button, OverlayTrigger, FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import { CirclePicker } from 'react-color';
import IconPopover from "../components/IconPopover";
import LoaderButton from "../components/LoaderButton";
import IconConfig from "../configs/IconConfig";
import config from "../configs/config";
import "./Events.css";

var moment = require("moment");
var DatePicker = require("react-bootstrap-date-picker");
var anchorme = require("anchorme").default;

export default class Events extends Component {
  constructor(props) {
    super(props);

    this.file = null;

    var isoDate = moment().format();
    var formattedDate = moment().format("MM/DD/YYYY");

    this.state = {
      isLoading: null,
      isDeleting: null,
      event: null,
      Content: "",
      Title: "",
      EventLocation: "",
      Color: "#000000",
      Icon: "",
      AttachmentURL: null,
      // Initialize as today's date. Will change to event's date
      // after the component mounts
      EventDate: isoDate,
      EventDateFormatted: formattedDate,
      EventEndDate: "",
      EventEndDateFormatted: ""
    };
  }

  async componentDidMount() {
    try {
      let AttachmentURL;
      const event = await this.getEvent();
      const { Content, Attachment, EventDate, EventEndDate, EventLocation, Title, SubTitle, Color, Icon } = event;

      if (Attachment) {
        AttachmentURL = await Storage.vault.get(Attachment);
      }

      this.setState({
        // Required fields
        event,
        Title,
        Color,
        Icon,
        EventDateFormatted: EventDate,
        EventDate: new Date(EventDate).toISOString(),
        // Optional fields
        AttachmentURL,
        SubTitle: SubTitle ? SubTitle : "",
        Content : Content ? Content : "",
        EventLocation: EventLocation ? EventLocation : "",
        EventEndDateFormatted: EventEndDate ? EventEndDate : "",
        EventEndDate: EventEndDate ? new Date(EventEndDate).toISOString() : ""
      });
    } catch (e) {
      alert(e);
    }
  }

  getEvent() {
    return API.get("events", `/events/${this.props.match.params.ID}`);
  }

  validateForm() {
    return this.validateProperty(this.state.Title) && this.validateProperty(this.state.EventDate);
  }

  validateProperty(property) {
    return property !== undefined && property !== null && property.length > 0;
  }

  formatFilename(str) {
    return str.replace(/^\w+-/, "");
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleColorChange = (color) => {
    this.setState({ Color: color.hex });
  };

  handleDateChange = (value, formattedValue) => {
    this.setState({
      EventDate: value,
      EventDateFormatted: formattedValue
    });
  }

  handleEndDateChange = (value, formattedValue) => {
    this.setState({
      EventEndDate: value,
      EventEndDateFormatted: formattedValue
    });
  }

  handleFileChange = event => {
    this.file = event.target.files[0];
  }

  selectIcon = (event) => {

    // Look for a sub element if this is a top level element
    var eventTarget = event.target;
    if(eventTarget.id === null || eventTarget.id === "") {
      if(eventTarget.nearestViewportElement !== undefined &&
        eventTarget.nearestViewportElement !== null &&
        eventTarget.nearestViewportElement.id !== null &&
        (eventTarget.nearestViewportElement.id.startsWith("IconSVG.") ||
        eventTarget.nearestViewportElement.id.startsWith("IconButton."))) {
        eventTarget = eventTarget.nearestViewportElement;
      } else {
        return;
      }
    }

    // Get the name from the SVG or the button
    var iconName = eventTarget.id;
    if(iconName.startsWith("IconSVG.")) {
      iconName = iconName.replace("IconSVG.", "");
    } else {
      iconName = iconName.replace("IconButton.", "");
    }

    // Set the selected icon in the state
    this.setState({
      Icon: iconName
    });
  }

  displayCurrentIcon = () => {
    const currentIcon = this.state.Icon;
    const IconElement = IconConfig.Icons.find(function(icon) {
      return icon.Name === currentIcon;
    });
    return <IconElement.Icon />
  }

  saveEvent(event) {
    return API.put("events", `/events/${this.props.match.params.ID}`, {
      body: event
    });
  }

  handleSubmit = async event => {
    let Attachment;

    event.preventDefault();

    if (this.file && this.file.size > config.MAX_ATTACHMENT_SIZE) {
      alert("Please pick a file smaller than 5MB");
      return;
    }

    this.setState({ isLoading: true });

    try {
      if (this.file) {
        Attachment = await s3Upload(this.file);
      }

      var content = this.replaceLinksInText(this.state.Content);

      await this.saveEvent({
        Title: this.state.Title,
        SubTitle: this.state.SubTitle,
        EventLocation: this.state.EventLocation,
        Content: content,
        Color: this.state.Color,
        Icon: this.state.Icon,
        Attachment: Attachment || this.state.event.Attachment,
        EventDate: this.state.EventDateFormatted,
        EventEndDate: this.state.EventEndDateFormatted,
        Username: this.state.event.Username
      });
      this.props.history.push("/");
    } catch (e) {
      alert(e);
      this.setState({ isLoading: false });
    }
  }

  replaceLinksInText(text) {
    if(text === undefined || text === null) {
      return null;
    }

    // don't run the conversion if there is already a link present
    if(text.indexOf('href') > 0) {
      return text;
    }

    return anchorme(text, {
      emails: false,
      ips: false,
      files: false,
      attributes:[{name: "target", value: "_blank"}]
    });
  }

  deleteEvent() {
    return API.del("events", `/events/${this.props.match.params.ID}`);
  }

  handleDelete = async event => {
    event.preventDefault();

    const confirmed = window.confirm(
      "Are you sure you want to delete this event?"
    );

    if (!confirmed) {
      return;
    }

    this.setState({ isDeleting: true });

    try {
      await this.deleteEvent();
      this.props.history.push("/");
    } catch (e) {
      alert(e);
      this.setState({ isDeleting: false });
    }
  }

  render() {
    return (
      <div className="Events">
        {this.state.event &&
          <form onSubmit={this.handleSubmit}>
            <FormGroup controlId="Title">
              <ControlLabel>Title</ControlLabel>
              <FormControl
                autoFocus
                type="text"
                onChange={this.handleChange}
                value={this.state.Title}
              />
            </FormGroup>
            <FormGroup controlId="SubTitle">
              <ControlLabel>Subtitle (Optional)</ControlLabel>
              <FormControl
                type="text"
                onChange={this.handleChange}
                value={this.state.SubTitle}
              />
            </FormGroup>
            <FormGroup controlId="EventLocation">
              <ControlLabel>Location (Optional)</ControlLabel>
              <FormControl
                type="text"
                onChange={this.handleChange}
                value={this.state.EventLocation}
              />
            </FormGroup>
            <FormGroup controlId="Content">
              <ControlLabel>Description (Optional)</ControlLabel>
              <FormControl
                onChange={this.handleChange}
                value={this.state.Content}
                componentClass="textarea"
              />
            </FormGroup>
            <FormGroup controlId="Color">
              <ControlLabel>Color</ControlLabel>
              <CirclePicker
                color={this.state.Color}
                onChangeComplete={this.handleColorChange}
               />
            </FormGroup>
            <FormGroup controlId="Icon">
              <ControlLabel>Icon</ControlLabel>
              <br />
              <OverlayTrigger
                trigger="click"
                rootClose
                overlay={<IconPopover onClick={this.selectIcon} />}>
                <Button>
                  Select Icon {this.displayCurrentIcon()} <span className="caret" />
                </Button>
              </OverlayTrigger>
            </FormGroup>
            <FormGroup controlId="eventDate">
              <ControlLabel>Event Date</ControlLabel>
              <DatePicker
                id="eventDatePicker"
                value={this.state.EventDate}
                onChange={this.handleDateChange}
                calendarPlacement="top"
              />
            </FormGroup>
            <FormGroup controlId="eventEndDate">
              <ControlLabel>Event End Date (Optional)</ControlLabel>
              <DatePicker
                id="eventEndDatePicker"
                value={this.state.EventEndDate}
                onChange={this.handleEndDateChange}
                calendarPlacement="top"
              />
            </FormGroup>
            {this.state.event.Attachment &&
              <FormGroup>
                <ControlLabel>Attachment (Optional)</ControlLabel>
                <FormControl.Static>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={this.state.AttachmentURL}
                  >
                    {this.formatFilename(this.state.event.Attachment)}
                  </a>
                </FormControl.Static>
              </FormGroup>}
            <FormGroup controlId="file">
              {!this.state.event.Attachment &&
                <ControlLabel>Attachment</ControlLabel>}
              <FormControl onChange={this.handleFileChange} type="file" />
            </FormGroup>
            <LoaderButton
              block
              bsStyle="primary"
              bsSize="large"
              disabled={!this.validateForm()}
              type="submit"
              isLoading={this.state.isLoading}
              text="Save"
              loadingText="Saving…"
            />
            <LoaderButton
              block
              bsStyle="danger"
              bsSize="large"
              isLoading={this.state.isDeleting}
              onClick={this.handleDelete}
              text="Delete"
              loadingText="Deleting…"
            />
          </form>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Events.js